import { useSelector } from 'react-redux';
import { useLanguageCode } from '@mews-commander/core';
import { getTexts } from '@mews-commander/core/legacy-globalization';
import { createIntlLocalizationProvider } from '@mews/framework';
import { getTextLocalizationInfo } from '../../core/globalization/selectors';

const { Provider, createMessagesWithDefaults } = createIntlLocalizationProvider();

export const IntlLocalizationProvider = ({ children }: React.PropsWithChildren<{}>) => {
    const languageCode = useLanguageCode();
    const texts = useSelector(getTexts);
    const languageChain = useTextLocalizationInfo(languageCode);
    const messagesWithDefaults = createMessagesWithDefaults(texts, languageChain);

    return (
        <Provider languageCode={languageCode} messagesWithDefaults={messagesWithDefaults} lazy>
            {children}
        </Provider>
    );
};

// TODO: Move this to a more general place
export function useTextLocalizationInfo(languageCode: string) {
    return useSelector((state) => {
        const { languageCodes } = getTextLocalizationInfo(state, { languageCode });
        return languageCodes;
    });
}
